export default __webpack_public_path__ + "static/media/module-lib.85665ef0.svg";